
// Valitions Errors
export const ERROR_EMAIL = "Please enter a valid email address.";
export const ERROR_REQUIRED = "This is a required field.";
export const ERROR_MINLENGTH = "Minimum 8 characters required";
export const ERROR_CONFIRM_PASS = "Passwords do not match";
export const ERROR_NUMBER = "Please enter a valid number.";
export const ERROR_ANPHANUMERIC = "Please enter a valid alphanumeric chars.";
export const ERROR_NETWORK_CONNECTION = "ERROR_NETWORK_CONNECTION";

export const SUCCESS_RESET_PASSWORD = "Password changed successfully";
export const ERROR_FORGOT_PASSWORD = "Email does not exist. Please try again";
export const ERROR_CHANGE_PASSWORD = "Change password failed";

// Patient form
export const SUCCESS_CREATE_PATIENT = "New patient created";
export const ERROR_CREATE_PATIENT = "Create new patient failed";
export const SUCCESS_UPDATE_PATIENT = "Update patient details is completed";
export const ERROR_UPDATE_PATIENT = "Update patient failed";
export const SUCCESS_DELETE_PATIENT = "Delete patient completed";
export const ERROR_DELETE_PATIENT = "Delete patient failed. Please try again";
export const ERROR_MEDICAL_NUMBER = "Patient already exists";

// Setting Form
export const SUCCESS_UPDATE_SETTING = "Update settings was successful";
export const ERROR_UPDATE_SETTING = "Update settings failed. Please try again";

// Profile Form
export const SUCCESS_UPDATE_PROFILE = "Update profile is completed";
export const ERROR_UPDATE_PROFILE = "Update your profile failed. Please try again";

// Assessment Form
export const ERROR_EMPTY_ANALYSIS = "Please fill in colours on image";

export const SUCCESS_CREATE_ANALYSIS = "Assessment Saved!";
export const ERROR_CREATE_ANALYSIS = "Create Assessment failed";

export const SUCCESS_UPDATE_ANALYSIS = "Assessment Saved!";
export const ERROR_UPDATE_ANALYSIS = "Update assessment failed";

export const SUCCESS_ADD_NOTE = "Note Saved";
export const ERROR_ADD_NOTE = "Add note failed";

export const SUCCESS_DELETE_ANALYSIS = "Delete assessment was successful";
export const ERROR_DELETE_ANALYSIS = "Delete assessment failed";

export const ERROR_EXPORT_PDF = "Please complete assessment before exporting to PDF";
export const WARNING_NO_EDIT = "No edit allowed 24 hours post assessment";
export const ANALYSIS_TITLE = ""; //"Analysis";

// User Signup
export const SUCCESS_USER_SIGNUP = "Your account has been created. Please check your email for verification";
export const ERROR_USER_SIGNUP = "Create new account failed. Please try again later";
export const SUCCESS_USER_ACTIVATED = "Your account has been activated successfully";
export const ERROR_USER_ACTIVATED = "Account activation failed. Please check the verification code and try again";

export const SUCCESS_CHECKOUT = "New subscription created. Page will refresh in 3 seconds";
export const SUCCESS_UPDATE_NEW_CARD = "Update payment to new card is successful";
export const ERROR_UPDATE_NEW_CARD = "Update payment to new card failed. Please try again";
export const SUCCESS_CANCEL_SUBSCRIPTION = "The subscription cancelled. The refreshing page after 3 seconds...";
export const ERROR_CANCEL_SUBSCRIPTION = "Subscription cancel failed. Please try again";

export const SUCCESS_REACTIVE_SUBSCRIPTION = "Re-activate subscription is completed";
export const ERROR_REACTIVE_SUBSCRIPTION = "Re-activate subscription failed. Please try again";

export const SUCCESS_CHANGE_SUBSCRIPTION = "Change plan is completed";
export const ERROR_CHANGE_SUBSCRIPTION = "Change plan failed. Please try again";

export const SUCCESS_CREATE_THERAPIST = "New Therapist created";
export const ERROR_CREATE_THERAPIST = "Create new Therapist failed";
export const SUCCESS_UPDATE_THERAPIST = "Update Therapist was successful";
export const ERROR_UPDATE_THERAPIST = "Update Therapist failed. Please try again";

export const POPUP_CHANGE_ASSESSMENT_TYPE = "By changing assessment type you will lose entered data. Please confirm.";
